import React from "react";
import { useDispatch } from "react-redux";
import { Box, Grid, Link, ListItemIcon, Tooltip, Fade, Typography, Theme } from "@mui/material";
// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";
import PostAddIcon from "@mui/icons-material/PostAdd";
import { GridRowModel } from "@mui/x-data-grid-premium";
import { useFormik } from "formik";
import moment from "moment";
import { searchData, downloadFile, sendEmailRequest } from "src/app-redux/common-actions";
import { useAppSelector } from "src/app-redux/hooks";
import { getCustomAlertData } from "src/app-redux/management/actions/managementActions";
import { selectCustomAlertData } from "src/app-redux/management/managementSlice";
import { getOrderStatusAction } from "src/app-redux/work-order/actions/workorderActions";
import { selectOrderStatus } from "src/app-redux/work-order/workOrderSlice";
import { getTimezoneName, setDateTimeFormate } from "src/common/utils/app.util";
import { useMyWinHeightContext } from "src/common/utils/getWindowDimensions";
import { moneyformatter } from "src/common/utils/helpers";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import CommonButton from "src/components/CommonButton/CommonButton";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import CommonTextField from "src/components/CommonTextField/CommonTextField";
import CommonTextFieldDate from "src/components/CommonTextFieldForDate/CommonTextFieldDate";
import CommonXGrid from "src/components/CommonXGrid/CommonXGrid";
import { GuiestIvrSetting } from "./GuestIvrSetting";

export const renderAddressCell = (params: any) => {
  const address = params.value;
  if (!address) return null;
  // prettier-ignore
  return (<Link component="button" variant="body2" onClick={(e: any) => { e.stopPropagation(); const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent( address )}`; const win: any = window.open(googleMapsUrl, "_blank"); win?.focus(); }}>{address} </Link>);
};

export const getAddressHyperlinkUrl = (value: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(value)}`;

function moneyColumn(field: string, headerName: string) {
  return {
    field,
    headerName,
    type: "number" as const,
    width: 110,
    align: "left" as const,
    headerAlign: "left" as const,
    valueFormatter: (params: any) => {
      if (!params.value) {
        return params.value;
      }
      return moneyformatter(params.value);
    },
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    marginLabelText: {
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
    },
    marginLabelHeading: {
      fontWeight: theme.typography.fontWeightRegular,
      color: "rgba(0, 0, 0, 0.54)",
      lineHeight: "20px",
    },
  })
);
export default function PrintVendorChecks() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { winHeight } = useMyWinHeightContext();
  const orderStatuses: any = useAppSelector(selectOrderStatus);
  const [loader, setLoader] = React.useState(false);
  const [ordersData, setOrdersData] = React.useState<GridRowModel[]>([]);
  const [woHistoryMonthLimit, setWoHistoryMonthLimit] = React.useState<string>("0");
  const [selectedOrders, setSelectedOrders] = React.useState<any>([]);
  const [isOpenDilog, setIsOpenDilog] = React.useState<boolean>(false);
  const [regionalMangerData, setRegionalMangerData] = React.useState<any>({});
  const customAlertData = useAppSelector(selectCustomAlertData);

  const columns = [
    {
      field: "poNum",
      headerName: "PO #",
      type: "string",
      width: 150,
      editable: false,
      renderCell: function customCell(params: any) {
        return (
          <Link
            component="button"
            variant="body2"
            onClick={(e: any) => {
              e.stopPropagation();
              const win: any = window.open(
                `/work-order/work-order-details/${params.row.ocdId}/${params.row.ordNum}/${params.row.crewId}`,
                "_blank"
              );
              win?.focus();
            }}
          >
            {params.value}
          </Link>
        );
      },
    },
    {
      field: "clientCode",
      headerName: "Client",
      type: "string",
      width: 150,
    },
    {
      field: "location",
      headerName: "Store Number",
      type: "string",
      width: 150,
    },
    {
      field: "company",
      headerName: "Location Name",
      type: "string",
      width: 150,
    },
    {
      field: "fullAddress",
      headerName: "Address",
      width: 300,
      renderCell: renderAddressCell,
      excelHyperlink: true,
      getHyperlinkUrl: getAddressHyperlinkUrl,
    },
    { field: "category", headerName: "Category", type: "string", width: 150 },
    {
      field: "orderType",
      headerName: "Order Type",
      type: "string",
      width: 170,
    },
    moneyColumn("nte", "Original NTE"),
    moneyColumn("deductions", "Deductions"),
    moneyColumn("totalNte", "Total NTE"),
    {
      field: "orderStatus",
      headerName: "WO Status",
      type: "string",
      width: 180,
    },
    {
      field: "clientPO",
      headerName: "Client PO",
      type: "string",
      width: 150,
    },
    {
      field: "acManagerName",
      headerName: "Account Manager",
      type: "string",
      width: 150,
      renderCell: function customCell(params: any) {
        return (
          <Link
            component="button"
            variant="body2"
            onClick={(e: any) => {
              e.stopPropagation();
              setIsOpenDilog(true);
              setRegionalMangerData(params.row);
            }}
          >
            {params.value}
          </Link>
        );
      },
    },
    {
      field: "workDate",
      headerName: "Work Date",
      type: "dateTime",
      width: 150,
      valueFormatter: (params: any) => {
        if (!params.value) {
          return params.value;
        }
        return setDateTimeFormate(params.value, "MM/DD/YYYY hh:mm A");
      },
    },
    {
      field: "icons",
      headerName: "",
      type: "string",
      width: 100,
      renderCell: function customCell(params: any) {
        return (
          <ListItemIcon>
            {params.row.signOffExist ? (
              <Tooltip
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 600 }}
                title={"SignOff Exist"}
                arrow
                placement="top"
              >
                <PostAddIcon style={{ fill: "red" }} />
              </Tooltip>
            ) : (
              <PostAddIcon color="disabled" />
            )}
            {params.row.vendorInvoiceExist ? (
              <Tooltip
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 600 }}
                title={"Vendor Invoice Exist"}
                arrow
                placement="top"
              >
                <PostAddIcon style={{ fill: "rgb(14 126 209)" }} />
              </Tooltip>
            ) : (
              <PostAddIcon color="disabled" />
            )}
          </ListItemIcon>
        );
      },
    },
  ];
  React.useEffect(() => {
    dispatch(getOrderStatusAction());
    if (!customAlertData || !Object.keys(customAlertData)?.length) {
      dispatch(getCustomAlertData());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (
      customAlertData &&
      Object.keys(customAlertData).length &&
      customAlertData.woHistoryMonthLimit
    ) {
      setWoHistoryMonthLimit(customAlertData.woHistoryMonthLimit);
    }
  }, [customAlertData]);

  const formik = useFormik({
    initialValues: {
      woStatus: "",
      poNum: "",
      locNum: "",
      beginDate:
        woHistoryMonthLimit === "0"
          ? moment().format("YYYY-MM-DD")
          : moment().subtract(1, "months").format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  const { values, setValues } = formik;

  React.useEffect(() => {
    setValues((prev) => ({
      ...prev,
      beginDate:
        woHistoryMonthLimit === "0"
          ? moment().format("YYYY-MM-DD")
          : moment().subtract(parseInt("1", 10), "months").format("YYYY-MM-DD"),
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [woHistoryMonthLimit]);

  const handleSearch = async () => {
    const { woStatus, beginDate, endDate, locNum, poNum } = values;
    const body = {
      wOStatus: woStatus || "",
      onsiteStartDate: beginDate || null,
      onsiteEndDate: endDate || null,
      locationNum: locNum || "",
      pONum: poNum || null,
    };
    setOrdersData([]);
    setSelectedOrders([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-order-by-vendor-num", JSON.stringify(body))
      );

      if (results?.vendors) {
        const transformedData = results.vendors.map((invoice: any) => {
          let conbine = invoice.city;
          if (conbine && invoice.state) conbine = `${conbine}, ${invoice.state}`;
          else if (invoice.state) conbine = invoice.state;
          return {
            ...invoice,
            id: invoice.ocdId,
            city_state: conbine,
            fullAddress: invoice.fullAddress,
            workDate: setDateTimeFormate(invoice.workDate, "YYYY-MM-DDTHH:mm"),
          };
        });
        setOrdersData(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }

    setLoader(false);
  };
  const handleCheckboxSelection = ({ selectionModel }: any) => {
    if (!ordersData.length && !selectionModel.length) {
      return setSelectedOrders([]);
    }
    const selectedRec = ordersData.filter(({ id }) => selectionModel.includes(id));
    setSelectedOrders(selectedRec);
  };
  const onSelectedAll = (isSelected: boolean) => {
    if (isSelected && ordersData.length) {
      return setSelectedOrders(ordersData);
    } else {
      return setSelectedOrders([]);
    }
  };
  const exportExcel = async () => {
    setLoader(true);
    const clone: any[] = [];
    ordersData.map((item: any) => {
      clone.push({
        workDate: item.workDate,
        nte: moneyformatter(item.nte),
        deductions: moneyformatter(item.deductions),
        totalNte: moneyformatter(item.totalNte),
        poNum: item.poNum,
        company: item.company,
        location: item.location,
        vendorFullAddress: item.fullAddress,
        orderType: item.orderType,
        orderStatus: item.orderStatus,
        clientPO: item.clientPO,
      });
    });
    await dispatch(downloadFile("export-order-by-vendor-excel", { ordersList: clone }));
    setLoader(false);
  };

  const sendWOEmail = async () => {
    setLoader(true);
    const newListPoNumbers: any = [];
    const newListIds: any = [];
    selectedOrders?.map((item: any) => {
      newListPoNumbers.push(item.poNum);
      newListIds.push(item.ocdId);
    });
    const body = {
      crewDetailIds: newListIds || [],
      vendorPONumbers: newListPoNumbers || [],
      actionType: 2,
      timezone: getTimezoneName(),
      documentId: -1,
      callSource: "vendorportal",
    };
    dispatch(
      sendEmailRequest(
        "/print-work-order-by-crew-detail-id",
        JSON.stringify(body),
        "Email will be sent to you shortly."
      )
    );
    setLoader(false);
  };
  const downloadWOPos = async () => {
    setLoader(true);
    const newListPoNumbers: any = [];
    const newListIds: any = [];
    selectedOrders?.map((item: any) => {
      newListPoNumbers.push(item.poNum);
      newListIds.push(item.ocdId);
    });
    const body = {
      crewDetailIds: newListIds || [],
      vendorPONumbers: newListPoNumbers || [],
      actionType: 3,
      timezone: getTimezoneName(),
      documentId: -1,
      callSource: "vendorportal",
    };
    await dispatch(downloadFile("/print-work-order-by-crew-detail-id", JSON.stringify(body)));
    setLoader(false);
  };
  let gridMaxHeight = 0;
  const dppr = 1000;
  gridMaxHeight = winHeight - 400;
  return (
    <>
      <CommonDrawer
        heading={"Account Manager"}
        isOpen={isOpenDilog}
        closeDrawer={() => {
          setIsOpenDilog(false);
        }}
        drawerWidth={300}
      >
        <Box mt={2} />
        <Box display={"flex"}>
          <Box color="text.secondary">
            <Typography className={classes.marginLabelHeading}>Name:</Typography>
          </Box>
          <Box className={classes.marginLabelText} mt={0.4} ml={1}>
            {regionalMangerData.acManagerName}
          </Box>
        </Box>
        <Box display={"flex"} mt={1}>
          <Box color="text.secondary">
            <Typography className={classes.marginLabelHeading}>Email:</Typography>
          </Box>
          <Box
            className={classes.marginLabelText}
            mt={0.2}
            ml={1.5}
            //style={{ textDecoration: "underline", cursor: "pointer" }}
          >
            <a
              href={`mailto:${regionalMangerData.acManagerEmail}?subject=PO#${regionalMangerData.poNum}`}
            >
              {regionalMangerData.acManagerEmail}
            </a>
          </Box>
        </Box>
      </CommonDrawer>
      <CommonDataGridPage
        module={"Work Orders"}
        heading={"Mobile Guest IVR Setting"}
        heading1={"List Of Work Orders"}
        pageTitle="TFG | Portal | Work Orders"
        forQuickPay
        customHeigth={110}
      >
        <Box>
          <GuiestIvrSetting />
        </Box>
      </CommonDataGridPage>
      <Box mt={1} />
      <CommonDataGridPage
        module={"Work Orders"}
        heading={"List Of Work Orders"}
        pageTitle="TFG | Portal | Work Orders"
        customHeigthOfGrid={257}
        notShowTabHeading
        GridDataComp={
          <CommonXGrid
            defaultPerPageRecord={dppr}
            rows={ordersData}
            columns={columns}
            height={gridMaxHeight}
            loader={loader}
            checkboxSelection
            initialColumnVisibilityModel={{ nte: false, deductions: false }}
            onSelectionModelChange={handleCheckboxSelection}
            onSelectedAll={onSelectedAll}
          />
        }
      >
        <>
          <Grid spacing={2} container direction="row">
            <Grid item xs={12} md={2}>
              <CommonTextFieldDate
                label={"Onsite Begin Date"}
                type={"date"}
                name={"beginDate"}
                value={
                  woHistoryMonthLimit === "0"
                    ? moment().format("YYYY-MM-DD")
                    : formik.values.beginDate
                }
                onChange={formik.handleChange}
                maxDate={formik.values.endDate}
                minDate={
                  woHistoryMonthLimit === "0"
                    ? moment().format("YYYY-MM-DD")
                    : moment()
                        .subtract(parseInt(woHistoryMonthLimit, 10), "months")
                        .format("YYYY-MM-DD")
                }
                required
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonTextFieldDate
                label={"Onsite End Date"}
                type={"date"}
                name={"endDate"}
                value={formik.values.endDate}
                onChange={formik.handleChange}
                minDate={formik.values.beginDate}
                required
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonAutoCompleteField
                label="WO Status"
                optionsType={orderStatuses}
                getOptionLabel={(option: any) => option.code || null}
                onChange={(row: any) => setValues({ ...values, woStatus: row?.code || "" })}
                value={
                  orderStatuses.find(
                    (val: any) => val?.code && val.code === formik.values.woStatus
                  ) || null
                }
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonTextField
                label="Location Id"
                onChange={formik.handleChange}
                name="locNum"
                value={formik.values.locNum}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <CommonTextField
                label="PO #"
                onChange={formik.handleChange}
                name="poNum"
                value={formik.values.poNum}
              />
            </Grid>
            <Grid item xs={12} md={2} direction="row">
              <Box textAlign="right" mt={0} mb={0}>
                <CommonButton onClick={() => setValues(formik.initialValues)}>Reset</CommonButton>
                <CommonButton isGreen onClick={handleSearch}>
                  Search
                </CommonButton>
              </Box>
            </Grid>
            <Grid item xs={12} md={12} direction="row">
              <Box textAlign="right" mt={-1} mb={1}>
                <CommonButton isGreen onClick={sendWOEmail} disable={selectedOrders?.length < 1}>
                  Email Selected POs
                </CommonButton>
                <CommonButton
                  isGreen
                  onClick={downloadWOPos}
                  disable={selectedOrders?.length < 1 || selectedOrders?.length > 20}
                >
                  Download Selected POs
                </CommonButton>

                <CommonButton isGreen disable={ordersData?.length < 1} onClick={exportExcel}>
                  Export all POs to Excel
                </CommonButton>
              </Box>
            </Grid>
          </Grid>
        </>
      </CommonDataGridPage>
    </>
  );
}
